'use client'

import { useEffect } from 'react'

import { initializeAppInsights } from '@/services/appInsights'

const AppInsightsProvider = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    initializeAppInsights()
  }, [])

  return <>{children}</>
}

export default AppInsightsProvider
